import React from 'react';

interface HeroVideoProps {
  video?: string;
}

const HeroVideo = ({ video }: HeroVideoProps) => {
  if (!video) return null;

  return (
    <div className="listing-hero-video-container">
      <video
        className="listing-hero-video"
        autoPlay={true}
        loop={true}
        muted={true}
        playsInline={true}
      >
        <source src={video} type="video/mp4" />
        <div className="listing-hero-background-image" />
      </video>
    </div>
  );
};

export default HeroVideo;
